// extracted by mini-css-extract-plugin
export default {"open":"openShop_open__ZDcgx","header":"openShop_header__xXUyE","grid":"openShop_grid__nCfux","newHeader":"openShop_newHeader__okHK9"};